






















































































































































import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  onMounted,
  watch,
} from '@vue/composition-api';
import Form from '@/components/Form/index.vue';
import Pagination from '@/components/Pagination';
import addComma from '@/utils/addComma';
import request from '@utils/request';
import { userInfor as userInfoRef, isCore } from '@/useable/login';
const userInfor = userInfoRef.value;

export default defineComponent({
  name: 'billList',
  components: {
    Form,
    Pagination,
  },
  setup(props: any, { root }: any) {
    const tableConfig = ref({
      column: [
        { key: 'applyNo', label: '融资申请单号', width: 210 },
        { key: 'vendorName', label: '融资企业名称', width: 210 },
        { key: 'bankName', label: '融资银行', width: 210 },
        {
          key: 'applyAmount',
          label: '融资金额',
          width: 130,
          custom: true,
          align: 'right',
          headerAlign: 'right',
        },
        { key: 'currencyCode', label: '币种', width: 70 },
        { key: 'financeRate', label: '融资利率', width: 120, custom: true },
        { key: 'applyDate', label: '融资申请日期', width: 120 },
        { key: 'applyStatusName', label: '融资申请状态', width: 110 },
        { key: 'repaymentStatsName', label: '融资还款状态', width: 110 },
        { key: 'repaymentDate', label: '融资还款日期', width: 110 },
        { key: 'repaymentAmount', label: '还款金额', width: 110,
          custom: true,
          align: 'right',
          headerAlign: 'right', },
        { key: 'unpaidAmount', label: '未还款金额', width: 110,
          custom: true,
          align: 'right',
          headerAlign: 'right', },
        { key: 'totalRepaymentInterest', label: '累计还款利息', width: 110,
          custom: true,
          align: 'right',
          headerAlign: 'right', },
        {
          key: 'creditLimit',
          label: '授信额度',
          width: 110,
          custom: true,
          align: 'right',
          headerAlign: 'right',
        },
        {
          key: 'residueLimit',
          label: '剩余额度',
          width: 110,
          custom: true,
          align: 'right',
          headerAlign: 'right',
        },
        { key: 'c', label: '操作', operate: true, width: 90 },
      ],
      data: [],
    });
    const state = reactive({
      loginstatus: false,
      form: {
        vendorName: isCore.value ? '' : userInfor.supplierName,
        orderStatus: '',
        orderNo: '',
      } as any,
      downloadUrl: 'dataFinancing-financeDetailExport',
      total: 0,
      pageSize: 10,
      page: 1,
      formSupplierColumn: [
        {
          name: 'vendorName',
          type: 'input',
          label: '融资企业名称：',
          disabled: true,
          placeholder: '输入融资企业名称',
        },
        {
          name: 'bankCode',
          type: 'select',
          label: '融资银行：',
          placeholder: '请选择',
          options: [],
        },
        {
          name: 'applyAmountFollow',
          type: 'number',
          label: '融资金额从：',
          placeholder: '请输入',
        },
        {
          name: 'applyAmountTo',
          type: 'number',
          label: '融资金额至：',
          placeholder: '请输入',
        },
        {
          name: 'applyNo',
          type: 'input',
          label: '融资申请单号：',
          placeholder: '输入融资申请单号',
        },
        {
          name: 'applyStatus',
          type: 'select',
          label: '融资申请状态：',
          placeholder: '输入融资申请状态',
          options: [
            {
              name: '受理中',
              value: '2',
            },
            {
              name: '已放款',
              value: '3',
            },
            {
              name: '融资失败',
              value: '4',
            },
          ],
        },
        {
          name: 'applyDate',
          type: 'daterange',
          label: '融资申请日期：',
          placeholder: '输入融资申请日期',
        },
        {
          name: 'repaymentStats',
          type: 'select',
          label: '融资还款状态：',
          placeholder: '输入融资还款状态',
          options: [
            {
              name: '未还款',
              value: '0',
            },
            {
              name: '部分还款',
              value: '1',
            },
            {
              name: '已还款',
              value: '2',
            },
            {
              name: '已逾期',
              value: '3',
            },
          ],
        },
      ],
      formBusinessColumn: [
        {
          name: 'vendorName',
          type: 'AsyncSelect',
          asyncName: 'parameter',
          label: '融资企业名称：',
          placeholder: '输入融资企业名称',
          url: 'dataFinancing-getVendorNameInfoSelect',
          options: [],
        },
        {
          name: 'bankCode',
          type: 'select',
          label: '融资银行：',
          placeholder: '请选择',
          options: [],
        },
        {
          name: 'applyAmountFollow',
          type: 'number',
          label: '融资金额从：',
          placeholder: '请输入',
        },
        {
          name: 'applyAmountTo',
          type: 'number',
          label: '融资金额至：',
          placeholder: '请输入',
        },
        {
          name: 'applyNo',
          type: 'AsyncSelect',
          asyncName: 'parameter',
          label: '融资申请单号：',
          placeholder: '输入融资申请单号',
          url: 'dataFinancing-getApplyNoInfoSelect',
          options: [],
        },
        {
          name: 'applyStatus',
          type: 'select',
          label: '融资申请状态：',
          placeholder: '输入融资申请状态',
          options: [
            {
              name: '受理中',
              value: '2',
            },
            {
              name: '已放款',
              value: '3',
            },
            {
              name: '融资失败',
              value: '4',
            },
          ],
        },
        {
          name: 'applyDate',
          type: 'daterange',
          label: '融资申请日期：',
          placeholder: '输入融资申请日期',
        },
        {
          name: 'repaymentStats',
          type: 'select',
          label: '融资还款状态：',
          placeholder: '输入融资还款状态',
          options: [
            {
              name: '未还款',
              value: '0',
            },
            {
              name: '部分还款',
              value: '1',
            },
            {
              name: '已还款',
              value: '2',
            },
            {
              name: '已逾期',
              value: '3',
            },
          ],
        },
      ],
    });
    watch(()=> state.form.applyDate, (newValue)=> {
      state.form.applyDateFollow =
          (newValue &&
            newValue.length > 0 &&
            newValue[0]) ||
          '';
      state.form.applyDateTo =
        (newValue &&
          newValue.length > 0 &&
          newValue[1]) ||
        '';
    });
    const getData = async () => {
      Promise.all([request('financing', 'bankList', {bankListFlag: 'dataFin'})]).then((result) => {
        if (result[0].code === 2000) {
          (
            (
              state[
                isCore.value ? 'formBusinessColumn' : 'formSupplierColumn'
              ] as any
            ).find(i => i.name === 'bankCode') as any
          ).options = result[0].data.map(i => ({
            value: i.bankCode,
            name: i.bankName,
          }));
        }
      });
    };

    const getBillList = async () => {
      const parms = {
        ...state.form,
        vendorName: isCore.value ? state.form.vendorName : userInfor.supplierId,
        current: state.page,
        pageSize: state.pageSize,
      };
      delete parms.applyDate;
      const res = await request('dataFinancing', 'getdataFinancingList', parms);
      if (res.code === 2000) {
        tableConfig.value.data = res.data.dataList;
        state.total = res.data.total;
      }
    };
    const getSupplierInfoSelect = async (query) => {
      const parms = {
        parameter: query,
        current: 1,
        size: 10,
      };
      const res = await request(
        'dataFinancing',
        'getVendorNameInfoSelect',
        parms,
      );
      if (res.code === 2000) {
        state.formBusinessColumn[0].options = res.data.map(i => ({
          value: i,
          name: i,
        }));
      }
    };
    const getApplyNoInfoSelect = async (query) => {
      const parms = {
        parameter: query,
        current: 1,
        size: 10,
      };
      const res = await request('dataFinancing', 'getApplyNoInfoSelect', parms);
      if (res.code === 2000) {
        (
          (
            state[
              isCore.value ? 'formBusinessColumn' : 'formSupplierColumn'
            ] as any
          ).find(i => i.name === 'applyNo') as any
        ).options = res.data.map(i => ({ value: i, name: i }));
      }
    };
    getApplyNoInfoSelect('');
    if (isCore.value) {
      getSupplierInfoSelect('');
      state.loginstatus = false;
    } else {
      state.loginstatus = true;
    }
    getBillList();
    const submit = async () => {
      getBillList();
    };

    const pageChange = (newPage, newSize) => {
      state.page = newPage;
      state.pageSize = newSize;
      submit();
    };

    const onSearch = (val) => {
      state.form = val;
      state.page = 1;
      // state.pageSize = 10;
      submit();
    };
    const checkDetail = (data) => {
      // root.$router.push({
      //   path: '/bill/detail',
      //   query: {
      //     orderNo: data
      //   }
      // });
      const routeUrl = root.$router.resolve(`/dataFinancing/detail/${data}`);
      window.open(routeUrl.href, '_blank');
    };
    onMounted(getData);
    return {
      ...toRefs(state),
      pageChange,
      onSearch,
      tableConfig,
      getBillList,
      checkDetail,
      getSupplierInfoSelect,
      addComma,
    };
  },
});
